define('v3/Pages/AbilityGraph/Services/Backend/backendReport',['jquery', 'module', 'BackendBase'], function ($, module, BackendBase) {
	var BackendReport = function () {
		BackendBase.call(this);
	};

	var actions = module.config().actions;

	var rainbowBaseUrl = module.config().rainbowBaseUrl;

	BackendReport.prototype = $.extend({}, BackendBase.prototype);
	$.extend(BackendReport.prototype, {
		getSubjects: function () {
			return this._post(actions.getSubjects, { });
		},
		getGetLearningObjectives: function (subjectId) {
			return this._post(actions.getGetLearningObjectives, { subjectId: subjectId });
		},
		getUserSubjectGroupAbilityHistory: function (userId, subjectGroupId) {
			return this._getJsonApi(actions.getUserSubjectGroupAbilityHistory, { userId: userId, subjectGroupId: subjectGroupId });
		},
		getUserSdAbilityHistory: function (userId, subjectGroupId, sdId) {
			return this._getJsonApi(actions.getUserSdAbilityHistory, { userId: userId, subjectGroupId: subjectGroupId, sdId: sdId });
		},
		getUserLoAbilityHistory: function (userId, subjectGroupId, loId) {
			return this._getJsonApi(actions.getUserLoAbilityHistory, { userId: userId, subjectGroupId: subjectGroupId, loId: loId });
		},
		rainbowChartBaseUrl: rainbowBaseUrl,
		updateUserTargetAbilityPercentile: function (subjectGroupId, pupilId, targetPercentile, isAutomaticTargetAbility) {
			return this._postApi(actions.updateUserTargetAbilityPercentile, {
				subjectGroupId: subjectGroupId,
				pupilId: pupilId,
				targetPercentile: targetPercentile,
				setAutomaticTargetAbility: isAutomaticTargetAbility
			});
		}
	});

	return new BackendReport();
});

